<template>
  <div id="app">
    <header class="header">
      <img id="header-image" class="header-image" alt="$FNDEX" src="./assets/1500x500.jpg">
      <div class="menu_box">
        <router-link to="/about" class="button-42">Home</router-link>
        <router-link to="/buyMOKIT" class="button-42">Buy $MOKIT</router-link>
        <router-link to="/whitepaper" class="button-42">White Paper</router-link>
        <router-link to="/StakeMokit" class="button-42">Stake</router-link>
        <router-link to="/MokitGame" class="button-42">MOKIT Game</router-link>
        <router-link to="/MokitChart" class="button-42">Chart</router-link>
        <router-link to="/MokitBurn" class="button-42">Burn</router-link>
      </div>
      <br>


    <div class="menu_box">
    <h1>MOKIT Price</h1>
    <div v-if="tokenPrice">
      <a href="https://app.uniswap.org/explore/pools/base/0x021cE6b719B14E8D3b37dEBf7b3dDB7De8486D76" class="contact-link" target="_blank"> <p>$USD {{ tokenPrice }}</p></a>
     
    </div>
    <div v-else>
      <p>...</p>
    </div>
  </div>
  <br>


    </header>
    <router-view></router-view>

    <footer class="footer_box">
  <div class="reference-links">
    <p><strong>See also at:</strong></p>
    <ul class="reference-list">
      <a href="https://memecoinseason.io/p/mocking-kitten-coin" target="_blank" style="margin-right: 10px;">⤷ Memecoinseason</a>
      <a href="https://coinpaprika.com/coin/mokit-mocking-kitten-coin/" target="_blank" style="margin-right: 10px;">⤷ Coinpaprika</a>
      <a href="https://www.livecoinwatch.com/price/MockingKittenCoin-MOKIT" target="_blank">⤷ Livecoinwatch</a>
      <a href="https://coincodex.com/crypto/mocking-kitten-coin/" target="_blank">⤷ CoinCodex</a>

      

    </ul>
  </div>

  <div class="footer-content">
    
    <p>&copy; 2024 Mocking Kitten Coin (MOKIT)</p>
    <p>
      <a href="mailto:mockingkittenmeme@gmail.com" class="contact-link">mockingkittenmeme@gmail.com</a> ✨
      <a href="https://x.com/mockingkitten" data-show-count="false" class="contact-link">Twitter</a> ✨
      <a href="https://t.me/MOKIT_Memecoin" class="contact-link">Telegram</a>
    </p>
  </div>
</footer>


  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      tokenPrice: null,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);

    axios
      .get(
        'https://api.geckoterminal.com/api/v2/simple/networks/base/token_price/0xa4a6bfc841acbc83bf439c302685bef4a6969831',
        {
          headers: {
            'accept': 'application/json',
          },
        }
      )
      .then(data => {
        if (data.data && data.data.data && data.data.data.attributes && data.data.data.attributes.token_prices) {
          this.tokenPrice = data.data.data.attributes.token_prices['0xa4a6bfc841acbc83bf439c302685bef4a6969831'];
        } else {
          console.error('Struct error:', data);
        }
        console.log("Price: " + this.tokenPrice);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const headerImage = document.getElementById('header-image');
      if (window.scrollY > 50) {
        headerImage.classList.add('small');
      } else {
        headerImage.classList.remove('small');
      }
    }
  }
};
</script>

<style>
#app {
  font-family: 'Comic Sans MS', cursive, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  background-color: #4682B4;
  margin: 0 auto;
  width: 80%;
}

.header {
  z-index: 1000; /* Ensure the header overlaps */
  background-color: #4682B4; /* Same background color for the header */
}

.header-image {
  width: 100%;
  height: auto;
  transition: height 0.3s ease;
}

.header-image.small {
  height: 5%; /* Reduced height when scrolling */
}

.menu_box {
  border-radius: 1rem;
  background-color: rgba(30, 30, 31, 0.5);
  border: 0px solid #ff69b4;
  margin: 0px 0;
  padding: 10px;
}

.button-42 {
  display: inline-block;
  padding: 0.5em 1.5em;
  border: 0.1em solid #ff69b4;
  margin: 0.5em;
  border-radius: 0.5em;
  box-sizing: border-box;
  text-decoration: none;
  font-family: 'Comic Sans MS', cursive, sans-serif;
  font-weight: 600;
  color: #fff;
  background-color: #ff69b4;
  text-align: center;
  transition: all 0.3s;
}

.button-42:hover {
  color: #ff69b4;
  background-color: #fff;
  border-color: #ff69b4;
}

.footer_box {
  background-color: rgba(30, 30, 31, 0.5);
  padding: 1.5rem 2rem;
  border-radius: 1rem;
  text-align: center;
  margin-top: 30px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer_box p {
  margin: 0.5rem 0;
}

.contact-link {
  text-decoration: none;
  color: #00ff00;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #ff69b4;
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  #app {
    width: 95%;
  }

  .menu_box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .button-42 {
    margin: 0.5em 0;
  }

  .footer_box {
    padding: 1rem;
  }

  .header-image.small {
    height: 10%; 
  }
}

@media (max-width: 480px) {
  .button-42 {
    padding: 0.3em 1em;
  }

  .footer_box {
    padding: 0.5rem;
  }

  .header-image.small {
    height: 15%; 
  }
}

h1 {
  font-size: 24px;
}

p {
  font-size: 18px;
}

.reference-links {
    margin-bottom: 20px;
  }

  .reference-links p {
    font-size: 1.2em;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .reference-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .reference-list li {
    margin: 8px 0;
  }

  .reference-list a {
    color: #f8c500;
    text-decoration: none;
    font-size: 1.1em;
  }

  .reference-list a:hover {
    text-decoration: underline;
  }

  .footer-content img {
    margin-bottom: 15px;
  }

  .contact-link {
    color: #ff69b4;
    text-decoration: none;
  }

  .contact-link:hover {
    text-decoration: underline;
  }
</style>
